<template>
  <div class="charts-book">
    <div class="charts-book__item">
      <el-collapse
        class="r-collapse charts-collapse"
        accordion
        v-model="isShow"
      >
        <r-text style="margin-bottom: 8px" color-type="field-placeholder">
          Источник данных
        </r-text>
        <el-collapse-item name="1" class="r-collapse-item__tree-wrapper">
          <template slot="title">
            <r-text
              class="charts-book__item-name"
              color-type="field-placeholder"
            >
              {{ `${bookName ? bookName : $t("input_ds:empty")}` }}
            </r-text>
          </template>
          <profile-tree
            :cicled="true"
            :node-click-handler="openObject"
            :active-layers="source_id"
            :active-layers-id="id"
            module="chartsTree"
          />
        </el-collapse-item>
      </el-collapse>
    </div>
    <div class="charts-book__item">
      <r-text style="margin-bottom: 8px" color-type="field-placeholder">
        Ось Х
      </r-text>
      <source-attributes
        :single="true"
        :active-fields="xTitle"
        @handleNodeClick="changeX($event)"
        :tree-data="getAttributes(allFields, true, false)"
      />
    </div>
    <div class="charts-book__item">
      <r-text style="margin-bottom: 8px" color-type="field-placeholder">
        Ряды
      </r-text>
      <source-attributes
        :single="false"
        :active-fields="activeFields"
        @handleNodeClick="changeY($event)"
        :tree-data="getAttributes(allFields, false, false)"
      />
    </div>
    <div class="charts-book__item">
      <el-button
        v-if="xTitle && activeFields.length"
        type="primary"
        class="r-button"
        @click="chartBuild"
      >
        Построить график
      </el-button>
    </div>
  </div>
</template>

<script>
import SourceAttributes from "@/components/map/components/source-attributes/source-attributes";
import profileTree from "@/components/profiles-tree/profiles-tree.vue";
import { getAttributes, parseObjectFields } from "@/utils/";

export default {
  components: {
    SourceAttributes,
    profileTree
  },
  data() {
    return {
      isShow: "",
      source_id: null,
      id: null,
      bookName: null,
      xTitle: null,
      isLoading: false,
      fields: null,
      fieldsData: null,
      xAxisField: [],
      isReady: false,
      activeFields: [],
      allFields: []
    };
  },
  watch: {
    "$store.state.charts.openedCharts": {
      handler: function() {
        this.openedCharts = this.$store.state.charts.openedCharts;
        this.layout = this.$store.state.charts.chartsLayout;
      },
      deep: true,
      immediate: true
    },
    "$store.state.charts.activeChart": {
      handler: function(value) {
        const chartId = Object.keys(value)[0];
        const chartData = this.$store.state.charts.chartsData[chartId];
        if (chartData) {
          const object = {
            source_id: chartData.source_id,
            id: chartData.id,
            name: chartData.title,
            xTitle: chartData.fieldsTitle,
            default_type: "geojson"
          };
          this.openObject("watch", object);
          this.xTitle = chartData.fieldsTitle;
          this.activeFields = [];
          chartData.data.forEach(e => {
            this.activeFields.push(e.dataTitle);
          });
        } else {
          this.bookName = "";
          this.isShow = "";
          this.xTitle = "";
          this.xAxisField = [];
          this.allFields = [];
          this.activeFields = [];
        }
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    async openObject(event, object) {
      const { datatype } = object;
      const validFields = [];
      let allFields;

      if (datatype === "model") return;
      if (event !== "watch" || this.bookName !== object.name) {
        this.isShow = "";
        this.xTitle = "";
        this.activeFields = [];
      }
      this.isLoading = true;
      this.source_id = object.source_id;
      this.bookName = object.name;
      this.id = object.id;

      const initialFields = await this.$store.dispatch("REQUEST", {
        url: `objectFields/${this.source_id}`
      });
      allFields = parseObjectFields(initialFields, false);

      allFields.forEach(e => {
        if (
          e.type !== "has_many" &&
          e.type !== "belongs_to" &&
          e.type !== "has_many_through"
        ) {
          validFields.push(e);
        }
      });

      this.allFields = validFields;
      this.fields = this.getAttribute(allFields);
      this.isLoading = false;
    },
    getAttribute(array) {
      let attributesList = [];
      array.forEach((e, i) => {
        if (
          (!e.system_field && (e.type === "integer" || e.type === "numeric")) ||
          e.title === "id"
        ) {
          let attributeItem = { id: i, label: e.title };
          attributesList.push(attributeItem);
        }
      });
      this.xAxisField = attributesList;
      this.rowField = attributesList;
      return attributesList;
    },
    changeX({ path }) {
      this.xTitle === path ? (this.xTitle = "") : (this.xTitle = path);
    },
    changeY({ path }) {
      // TODO: make another default styles or add rules
      if (this.activeFields.length >= 8) {
        console.log("too much active fields");
        return;
      }
      let index = this.activeFields.indexOf(path);
      if (index > -1) {
        this.activeFields.splice(index, 1);
      } else {
        this.activeFields.push(path);
      }
    },
    async chartBuild() {
      const chartId = Object.keys(this.$store.state.charts.activeChart)[0];
      this.$store.commit("CHANGE_CHART_SOURCE", {
        source_id: this.source_id,
        id: this.id,
        chartName: this.bookName,
        xAxis: this.xTitle,
        yAxis: this.activeFields,
        chartId
      });
      await this.$store.dispatch("SAVE_MAIN_USER_CONFIG");
    },
    getAttributes
  }
};
</script>

<style lang="scss">
.charts-book {
  overflow: hidden;
  padding: 0;
  &__item {
    padding-bottom: 16px;
    &-name {
      display: flex;
      align-items: center;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
  .r-button {
    margin-top: 4px;
    width: 100%;
    height: 34px;
  }
  .r-collapse-item__tree-wrapper {
    .el-collapse-item__content {
      max-height: 300px;
      height: 100%;
      position: relative;
      .profile-tree {
        .tree-wrapper {
          max-height: 240px;
          overflow-y: auto;
        }
      }
    }
  }
}
</style>

<i18n>
{
  "ru": {
    "input_ds:empty": "Не выбран"
  },
  "en": {
    "input_ds:empty": "Not selected"
  }
}
</i18n>
